import { connect } from 'react-redux';
import LoginView from './index'
import {login} from '../../actions/Session'

const mapStateToProps = (state, props) => {
    return {
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	login: (data) => {
	    return dispatch(login(data))
	}
    }
}

const LoginContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginView);




export default LoginContainer;



// WEBPACK FOOTER //
// ./src/components/Login/Container.js